import { cn } from '@/utils';

type Props = React.HTMLAttributes<HTMLDivElement>;

const TypingIndicator = ({
  className,
  wrapperClassName,
  ...props
}: Props & { wrapperClassName?: string }) => {
  return (
    <div className={cn('flex gap-1', wrapperClassName)} {...props}>
      <div
        className={cn(
          'rounded-full w-1.5 h-1.5 bg-white animate-bounce',
          className
        )}
      ></div>
      <div
        className={cn(
          'rounded-full w-1.5 h-1.5 bg-white animate-bounce delay-200',
          className
        )}
      ></div>
      <div
        className={cn(
          'rounded-full w-1.5 h-1.5 bg-white animate-bounce',
          className
        )}
      ></div>
    </div>
  );
};

export { TypingIndicator };
